import Signal from 'signals';
export default {
    LoggedOut: new Signal(),
    LoggedIn: new Signal(),
    RootClick: new Signal(),
    KeyDown: new Signal(),
    // Asset refreshing
    ToggleAssetRefreshingOnInterval: new Signal(),
    RefreshAssets: new Signal(),
    //
    ShowLoadingScreen: new Signal(),
    HideLoadingScreen: new Signal(),
    ProgressUpload: new Signal(),
    // Messages
    ShowNotification: new Signal(),
    ShowConfirmModal: new Signal(),
    ShowAlertModal: new Signal(),
    // Overlay
    ShowOverlay: new Signal(),
    HideOverlay: new Signal(),
    OverlayBackgroundClick: new Signal(),
    ChangeAssetViewState: new Signal(),
    AssetsRetrieved: new Signal(),
    ResizeMap: new Signal(),
    ChangeServiceEntriesViewState: new Signal(),
    ShowAssetDetail: new Signal(),
    HideAssetDetail: new Signal(),
    LabelModelAdded: new Signal(),
    HashChanged: new Signal(),
    // Service Entries
    ServiceEntryAdded: new Signal(),
    ServiceEntryUpdated: new Signal(),
    ServiceEntryClosed: new Signal()
};
